var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import Spinner from "../Spinner/Spinner";
import { classNames } from "../Util";
var Alert = function (_a) {
    var type = _a.type, title = _a.title, description = _a.description, className = _a.className, actions = _a.actions;
    var bgColor;
    var bgActionHoverColor;
    var actionFocusRing;
    var icon;
    var titleColor;
    var bgColorDisabled;
    var descriptionColor;
    switch (type) {
        case "danger":
            bgColor = "bg-red-50";
            icon = _jsx(XCircleIcon, { className: "h-5 w-5 text-red-400", "aria-hidden": "true" });
            titleColor = "text-red-800";
            descriptionColor = "text-red-700";
            bgActionHoverColor = "hover:bg-red-100";
            bgColorDisabled = "bg-red-100";
            actionFocusRing = "focus:ring-red-600 focus:ring-offset-red-50";
            break;
        case "success":
            bgColor = "bg-green-50";
            icon = _jsx(CheckCircleIcon, { className: "h-5 w-5 text-green-400", "aria-hidden": "true" });
            titleColor = "text-green-800";
            descriptionColor = "text-green-700";
            bgActionHoverColor = "hover:bg-green-100";
            bgColorDisabled = "bg-green-100";
            actionFocusRing = "focus:ring-green-600 focus:ring-offset-green-50";
            break;
        case "info":
            bgColor = "bg-blue-50";
            icon = _jsx(InformationCircleIcon, { className: "h-5 w-5 text-blue-400", "aria-hidden": "true" });
            titleColor = "text-blue-800";
            descriptionColor = "text-blue-700";
            bgActionHoverColor = "hover:bg-blue-100";
            bgColorDisabled = "bg-blue-100";
            actionFocusRing = "focus:ring-blue-600 focus:ring-offset-blue-50";
            break;
        case "warning":
            bgColor = "bg-yellow-50";
            icon = _jsx(ExclamationTriangleIcon, { className: "h-5 w-5 text-yellow-400", "aria-hidden": "true" });
            titleColor = "text-yellow-800";
            descriptionColor = "text-yellow-700";
            bgActionHoverColor = "hover:bg-yellow-100";
            bgColorDisabled = "bg-yellow-100";
            actionFocusRing = "focus:ring-yellow-600 focus:ring-offset-yellow-50";
            break;
    }
    return (_jsx("div", __assign({ className: "rounded-md ".concat(bgColor, " p-4 ").concat(className ? className : "") }, { children: _jsxs("div", __assign({ className: "flex" }, { children: [_jsx("div", __assign({ className: "flex-shrink-0" }, { children: icon })), _jsxs("div", __assign({ className: "ml-3" }, { children: [_jsx("h3", __assign({ className: "text-sm font-medium ".concat(titleColor) }, { children: title })), description &&
                            _jsx("div", __assign({ className: "mt-2 text-sm ".concat(descriptionColor) }, { children: _jsx("p", { children: description }) })), actions &&
                            _jsx("div", __assign({ className: "mt-4" }, { children: _jsx("div", __assign({ className: "-mx-2 -my-1.5 flex" }, { children: actions.map(function (action, index) { return (_jsxs("button", __assign({ type: "button", onClick: action.onClick, disabled: action.loading, className: classNames("inline-flex justify-center rounded-md px-2 py-1.5 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", index !== 0 ? "ml-3" : "", bgColor, titleColor, bgActionHoverColor, actionFocusRing, action.loading ? "".concat(bgColorDisabled, " opacity-50") : "") }, { children: [action.loading && _jsx(Spinner, { color: titleColor }), action.text] }), index)); }) })) }))] }))] })) })));
};
export default Alert;
